import React, { useEffect, useState } from 'react'
import { StyleProp, Text, View, ViewStyle, Platform } from 'react-native'
import { Dropdown } from 'react-native-element-dropdown'
import { styles } from './styles'
import { useTranslation } from 'react-i18next'
import { corporateColor, white } from '../../theme/colors'
import { handleColorState } from '../../helpers/handleColorsState'
import { Option } from '../../context/FreshWater/types'

const DEFAULT_OPTION = 'Seleccione'

interface Props {
  data: Option[]
  hasSearch?: boolean
  label?: string
  onChange: (value: number, item?: Option) => void
  placeholder?: string
  hasChangeColor?: boolean
  customStyles?: StyleProp<ViewStyle>
  containerStyles?: StyleProp<ViewStyle>
  defaultOption?: { id: number; name: string }
  hasIcon?: boolean
  disabled?: boolean
  resetTrigger?: boolean
}

export const DropdownComponent = ({
  placeholder,
  label,
  data,
  hasSearch,
  onChange,
  hasChangeColor,
  customStyles,
  defaultOption,
  hasIcon,
  containerStyles,
  resetTrigger,
  disabled = false,
}: Props) => {
  const [value, setValue] = useState<Option>(defaultOption ?? { id: 0, name: DEFAULT_OPTION })

  const { t: translation } = useTranslation()

  const handleOnChange = (item: Option) => {
    setValue(item)
    onChange(item.id, item)
  }

  const handleColorDropdown = (changeColor: boolean): string =>
    changeColor ? (value.name === DEFAULT_OPTION ? corporateColor : white) : corporateColor

  useEffect(() => {
    if (resetTrigger) {
      setValue(defaultOption ?? { id: 0, name: DEFAULT_OPTION })
      onChange((defaultOption ?? { id: 0, name: DEFAULT_OPTION }).id, undefined)
    }
  }, [resetTrigger])

  return (
    <View
      style={[
        styles.container,
        hasChangeColor && { backgroundColor: handleColorState(value.name) },
        containerStyles,
      ]}
    >
      {value && label && <Text style={styles.label}>{translation(label)}</Text>}

      <Dropdown
        data={data}
        style={[styles.dropdown, customStyles]}
        placeholderStyle={styles.placeholderStyle}
        selectedTextStyle={[
          styles.selectedTextStyle,
          {
            color: handleColorDropdown(!!hasChangeColor),
          },
        ]}
        inputSearchStyle={styles.inputSearchStyle}
        iconStyle={[styles.iconStyle, !hasIcon && { display: 'none' }]}
        iconColor={handleColorDropdown(!!hasChangeColor)}
        search={hasSearch}
        maxHeight={Platform.OS === 'web' ? 500 : 250}
        disable={disabled}
        labelField='name'
        valueField='id'
        dropdownPosition='auto'
        autoScroll={false}
        placeholder={`${translation(placeholder ?? '')}`}
        searchPlaceholder={`${translation('BUSCAR')}...`}
        value={value}
        onChange={handleOnChange}
        itemTextStyle={styles.itemTextStyle}
        activeColor='#f0f0f0'
      />
    </View>
  )
}
